class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function FunctionPredicate(n,s,b){if(Array.isArray(s)&&b){const f=(...a)=>FunctionPredicate(n,b(...a));f.typeParamNames=s.map(p=>Array.isArray(p)?p[0]:p);f.description=n;f.__runtimeType=true;return f}const spec=typeof s==='function'?{}:s||{};return{description:n,params:spec.params||{},returns:spec.returns,returnContract:spec.returnContract||'assertReturns',check:v=>typeof v==='function',__runtimeType:true}};
function Union(d,...v){const vals=v.flat();return{description:d,check:x=>vals.includes(x),values:vals,__runtimeType:true}};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack,Type,FunctionPredicate,Union};
/* tjs <- css.ts */

/*#
# CSS

`tosijs` provides a collection of utilities for working with CSS rules that
help leverage CSS variables to produce highly maintainable and lightweight
code that is nonetheless easy to customize.

> The design goal of `css`, `vars`, and `varDefault` is to make working with
> CSS3 more intuitive, maintainable, easier, and expressive than using libraries
> like Tailwind.

The basic goal is to be able to implement some or all of our CSS very efficiently, compactly,
and reusably in Javascript because:

- Javascript quality tooling is really good, CSS quality tooling is terrible
- Having to write CSS in Javascript is *inevitable* so it might as well be consistent and painless
- It turns out you can get by with *much less* and generally *simpler* CSS this way
- You get some natural wins this way. E.g. writing two definitions of `body {}` is easy to do
  and bad in CSS. In Javascript it's simply an error!

The `css` module attempts to implement all this the simplest and most obvious way possible,
providing syntax sugar to help with best-practices such as `css-variables` and the use of
`@media` queries to drive consistency, themes, and accessibility.

## css(styleMap: XinStyleMap): string

A function that, given a `XinStyleMap` renders CSS code. What is a XinStyleMap?
It's kind of what you'd expect if you wanted to represent CSS as Javascript in
the most straightforward way possible. It allows for things like `@import`,
`@keyframes` and so forth, but knows just enough about CSS to help with things
like autocompletion of CSS rules (rendered as camelcase) so that, unlike me, it
can remind you that it's `whiteSpace` and not `whitespace`.

```
import {elements, css} from 'tosijs'
const {style} = elements

const myStyleMap = {
  body: {
    color: 'red'
  },
  button: {
    borderRadius: 5
  }
}

document.head.append(style(css(myStyleMap)))
```

There's a convenient `Stylesheet()` function that does all this and adds an id to the
resulting `<style>` element to make it easier to figure out where a given stylesheet
came from.

```
Stylesheet('my-styles', {
  body: {
    color: 'red'
  },
  button: {
    borderRadius: 5
  }
})
```

…inserts the following in the `document.head`:

```
<style id="my-styles">
body {
  color: red;
}
button {
  border-radius: 5px;
}
</style>
```

If a bare, non-zero **number** is assigned to a CSS property it will have 'px' suffixed
to it automatically. There are *no bare numeric*ele properties in CSS except `0`.

Why `px`? Well the other obvious options would be `rem` and `em` but `px` seems the
least surprising option.

`css` should render nested rules, such as `@keyframes` and `@media` correctly.

## Initializing CSS Variables

You can initialize CSS variables using `_` or `__` prefixes on property names.
One bar, turns the camelCase property-name into a --snake-case CSS variable
name, while two creates a default that can be overridden.

```
StyleSheet('my-theme', {
  ':root', {
    _fooBar: 'red',
    __bazBar: '10px'
  }
})
```

Will produce:

```
<style id="my-theme">
  :root {
    --foo-bar: red;
    --baz-bar: var(--baz-bar-default, 10px);
  }
</style>
```
```js
import { elements, vars } from 'tosijs'
const { div } = elements

window.CSS.registerProperty({
  name: '--at-bar',
  syntax: '<color>',
  inherits: true,
  initialValue: 'green',
})

preview.append(
  div(
    {
      style: {
        _fooBar: 'red',
        __bazBar: 'blue',
      }
    },
    div(
      {
        style: { color: vars.fooBar },
      },
      'fooBar'
    ),
    div(
      {
        style: { color: vars.bazBar },
      },
      'bazBar'
    ),
    div(
      {
        style: { color: vars.atBar },
      },
      'atBar'
    ),
  )
)
```

> ### @property and CSS.registerProperty() considered harmful
>
> This [new CSS feature}(https://developer.mozilla.org/en-US/docs/Web/CSS/@property)
> is well-intentioned but ill-considered. I advise
> against using it yourself until its serious flaws are addressed. The problem
> is that if someone registers a variable you're using or you register
> a variable someone else is using then your CSS may be broken. And
> you can't re-register a variable either.

> This is a bit like the problem
> that tosijs Component works around with tagNames, but in practice far more
> difficult to solve. It is impossible to tell if a given instance of
> a given variable name is an intentional reuse or a new separate variable.
> No-one intentionally defines two different components with the same tag.

## invertLuminance({[key: string]: any}) => {[key: string]: string}

Given a map of CSS properties (in camelCase) emit a map of those properties that
has color values with their luminance inverted.

    const myStyleMap = {
      ':root': cssVars,                      // includes --font-size
      '@media (prefers-color-scheme: dark)': {
        ':root': invertLuminance(cssVars)    // omits --font-size
      },
    }

## vars

`vars` is a proxy object that will return a css variable string from
a camelCase property, e.g.

    vars.camelCase // 'var(--camel-case)'

> **it isn't called `var`** because that's a reserved word!

### varDefault

`varDefault` is a proxy object just like `vars` except that it returns a
`function` that takes a property and renders it as a css variable reference
with a default, e.g

    varDefault.borderColor('red') // `var(--border-color, red)`

## `getCssVar(variable: string, atElement = document.body): string`

`getCssVar()` obtains the css variable evaluated at the specified element
(an element defined at `:root` can be evaluated at `document.body`). You
can provide the name, e.g. `--foo-bar`, or "wrapped", e.g. `var(--foo-bar)`.

### Syntax Sugar for `calc(...)`

More importantly, `vars` allows you to conveniently perform calculations
on css (dimensional) variables by a percentage:

    vars.camelSize50    // 'calc(var(--camel-size) * 0.5)'
    vars.camelSize_50   // 'calc(var(--camel-size) * -0.5)'

### Computed Colors

> #### Notes
>
> `color()` and `color-mix()` are [now enjoy 91% support](https://caniuse.com/?search=color-mix) as of writing.
> See [color-mix()](https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/color-mix) documentation.
> Where they meet your needs, I'd suggest using them.
>
> [contrast-color()](https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/contrast-color) is coming in Safari 26,
> but [currently enjoys 0% upport](https://caniuse.com/?search=contrast-color).
>
> **Caution** although these look superficially like the `vars` syntax
> sugar for `calc()` performed on dimensional variables, they are in fact
> color calculations are performed on colors *evaluated* on `document.body` at
> execution time. (So they won'b automatically be recomputed on theme change.)

You can write:

```
const styleSpec = {
  _lineHeight: 24,
  _spacing: 5,
  _buttonHeight: calc(`vars.lineHeight + vars.spacing200`)
)
```

And then render this as CSS and stick it into a StyleNode and it will work.

You *cannot* write:

```
const styleSpec = {
  _background: '#fafafa',
  _blockColor: vars.background_5b
}
```

Because `--background` isn't defined on `document.body` yet, so vars.background_5b
won't be able to tell what `--background` is going to be yet. So either you need to
do this in two stags (create a StyleNode that defines the base color `--background`
then define the computed colors and add this) OR use a `Color` instance:

```
const background = Color.fromCss('#fafafa')

initVars({
  background: background.toHTML,
  blockColor: background.brighten(-0.05).toHTML
})
```

Until browsers support color calculations the way they support dimension arithmetic with `calc()`
this is the miserable existence we all lead. That, or defining huge arrays of color
values that we mostly don't use and are often not exactly what we want. You choose!

> **New** color now supports CSS [named colors](https://developer.mozilla.org/en-US/docs/Web/CSS/named-color),
such as `black`, `red`, and `aliceblue`.

`vars` also allows you to perform color calculations on css (color)
variables:

#### Change luminance with `b` (for brighten) suffix

The scale value is treated as a percentage and moves the brightness
that far from its current value to 100% (if positive) or 0% (if negattive).

    vars.textColor50b   // increases the luminance of textColor
    vars.textColor_50b  // halves the luminance of textColor

#### Change saturation with `s` suffix

The scale value is treated as a percentage and moves the saturation
that far from its current value to 100% (if positive) or 0% (if negattive).

    vars.textColor50s   // increases the saturation of textColor
    vars.textColor_50s  // halves the saturation of textColor

#### Rotate hue with `h` suffix

    vars.textColor30h   // rotates the hue of textColor by 30°
    vars.textColor_90h  // rotates the hue of textColor by -90°

#### Set Opacity with `o` suffix

Unlike the other modifiers, `o` simply sets the opacity of the
resulting color to the value provided.

    vars.textColor50o   // textColor with opacity set to 0.5

## More to follow?

The more I use the `css` module, the more I like it and the more ideas I have
to make it even better, but I have a very tight size/complexity target
for `tosijs` so these new ideas really have to earn a spot. Perhaps the
feature I have come closest to adding and then decided against was providing
syntax-sugar for classs so that:

    css({
      _foo: {
        color: 'red'
      }
    })

Would render:

    .foo {
      color: 'red'
    }

But looking at the code I and others have written, the case for this is weak as most class
declarations are not just bare classes. This doesn't help with declarations
for `input.foo` or `.foo::after` or `.foo > *` and now there'd be things that
look different which violates the "principle of least surprise". So, no.

### Something to Declare

Where I am always looking to improve this module (and all of `tosijs`) is to
do a better job of **declaring** things to improve autocomplete behavior and
minimize casting and other Typescript antipatterns. E.g. adding a ton of
declarations to `elements` and `css` has done wonders to reduce the need for
stuff like `const nameElement = this.parts.nameField as unknown as HTMLInputElement`
and prevent css property typos without adding a single byte to the size of
the javascript payload.

## onStylesheetChange(callback: () => void): () => void

Registers a callback that fires whenever any observant stylesheet regenerates
(i.e., when a proxy-backed `StyleSheet` detects a change and rewrites its CSS).
Returns an unsubscribe function.

    const unsub = onStylesheetChange(() => {
      console.log('a stylesheet was updated')
    })

    // later
    unsub()
*/

import { Color } from './color'

import { elements } from './elements'

import { camelToKabob } from './string-case'

import { XinStyleSheet, XinStyleRule } from './css-types'

import { warnDeprecated, tosiPath, tosiValue } from './metadata'

import { observe } from './xin'

const stylesheetChangeCallbacks = new Set();

let colorListenerRegistered = false;

/* line 360 */
function ensureColorListener() {
    if (!colorListenerRegistered) {
        colorListenerRegistered = true;
        stylesheetChangeCallbacks.add(() => Color.queueRecompute());
    }
}
ensureColorListener.__tjs = {
  "params": {},
  "source": "css.ts:360"
}

/* line 367 */
export function onStylesheetChange(callback) {
  try {
  __tjs.pushStack('css.ts:375:onStylesheetChange');
  if (callback instanceof Error) return callback;

    stylesheetChangeCallbacks.add(callback);
    return () => stylesheetChangeCallbacks.delete(callback);

  } finally { __tjs.popStack(); }
}
onStylesheetChange.__tjs = {
  "params": {
    "callback": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    }
  },
  "source": "css.ts:375"
}

/* line 372 */
function notifyStylesheetChange() {
    ensureColorListener();
    for (const callback of stylesheetChangeCallbacks) {
        callback();
    }
}
notifyStylesheetChange.__tjs = {
  "params": {},
  "source": "css.ts:372"
}

/* line 379 */
/* TODO: TS types degraded — styleSpec: XinStyleSheet */
export function StyleSheet(id, styleSpec) {
  try {
  __tjs.pushStack('css.ts:390:StyleSheet');
  if (id instanceof Error) return id;
  if (styleSpec instanceof Error) return styleSpec;
  if (typeof id !== 'string') return __tjs.typeError('css.ts:390:StyleSheet.id', 'string', id);

    const spec = tosiValue(styleSpec);
    const element = elements.style(css(spec));
    element.id = id;
    document.head.append(element);
    // If styleSpec is a proxy, observe it for changes
    const path = tosiPath(styleSpec);
    if (path !== undefined) {
        observe(path, () => {
            element.textContent = css(tosiValue(styleSpec));
            notifyStylesheetChange();
        });
    }

  } finally { __tjs.popStack(); }
}
StyleSheet.__tjs = {
  "params": {
    "id": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "styleSpec": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "css.ts:390"
}

const unitless = /^(animation-iteration-count|column-count|flex(-grow|-shrink)?|font-weight|line-height|opacity|order|orphans|scale|tab-size|widows|z-index|zoom)$/;

/* line 399 */
export function processProp(prop,value) {
  try {
  __tjs.pushStack('css.ts:408:processProp');
  if (prop instanceof Error) return prop;
  if (value instanceof Error) return value;
  if (typeof prop !== 'string') return __tjs.typeError('css.ts:408:processProp.prop', 'string', prop);
  if ((typeof value !== 'string' && typeof value !== 'number')) return __tjs.typeError('css.ts:408:processProp.value', 'string | number', value);

    if (typeof value === 'number' && !unitless.test(prop)) {
        value = `${value}px`;
    }
    if (prop.startsWith('_')) {
        if (prop.startsWith('__')) {
            prop = '--' + prop.substring(2);
            value = `var(${prop}-default, ${value})`;
        }
        else {
            prop = '--' + prop.substring(1);
        }
    }
    return {
        prop,
        value: String(value),
    };

  } finally { __tjs.popStack(); }
}
processProp.__tjs = {
  "params": {
    "prop": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "value": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "string"
          },
          {
            "kind": "number"
          }
        ]
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {
        "prop": {
          "kind": "string"
        },
        "value": {
          "kind": "string"
        }
      }
    }
  },
  "unsafeReturn": true,
  "source": "css.ts:408"
}

/* line 420 */
/* TODO: TS types degraded — value: string | number | Color | undefined */
function renderProp(indentation,cssProp, value) {
  try {
  __tjs.pushStack('css.ts:429:renderProp');
  if (indentation instanceof Error) return indentation;
  if (cssProp instanceof Error) return cssProp;
  if (value instanceof Error) return value;
  if (typeof indentation !== 'string') return __tjs.typeError('css.ts:429:renderProp.indentation', 'string', indentation);
  if (typeof cssProp !== 'string') return __tjs.typeError('css.ts:429:renderProp.cssProp', 'string', cssProp);

    if (value === undefined) {
        return '';
    }
    if (value instanceof Color) {
        value = value.html;
    }
    const processed = processProp(cssProp, value);
    return `${indentation}  ${processed.prop}: ${processed.value};`;

  } finally { __tjs.popStack(); }
}
renderProp.__tjs = {
  "params": {
    "indentation": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "cssProp": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "value": {
      "type": {
        "kind": "any"
      },
      "required": true
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "css.ts:429"
}

/* line 435 */
/* TODO: TS types degraded — value: Color | string | number | XinStyleRule | undefined */
function renderStatement(key, value, indentation = '') {
  try {
  __tjs.pushStack('css.ts:442:renderStatement');
  if (key instanceof Error) return key;
  if (value instanceof Error) return value;
  if (indentation instanceof Error) return indentation;
  if (typeof key !== 'string') return __tjs.typeError('css.ts:442:renderStatement.key', 'string', key);
  if (indentation !== undefined && typeof indentation !== 'string') return __tjs.typeError('css.ts:442:renderStatement.indentation', 'string', indentation);

    const cssProp = camelToKabob(key);
    if (typeof value === 'object' && !(value instanceof Color)) {
        const renderedRule = Object.keys(value)
            .map((innerKey) => renderStatement(innerKey, value[innerKey], `${indentation}  `))
            .join('\n');
        return `${indentation}  ${key} {\n${renderedRule}\n${indentation}  }`;
    }
    else {
        return renderProp(indentation, cssProp, value);
    }

  } finally { __tjs.popStack(); }
}
renderStatement.__tjs = {
  "params": {
    "key": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "value": {
      "type": {
        "kind": "any"
      },
      "required": true
    },
    "indentation": {
      "type": {
        "kind": "string"
      },
      "required": false,
      "default": ""
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "css.ts:442"
}

/* line 453 */
/* TODO: TS types degraded — obj: XinStyleSheet */
export function css(obj, indentation = '') {
  try {
  __tjs.pushStack('css.ts:457:css');
  if (obj instanceof Error) return obj;
  if (indentation instanceof Error) return indentation;
  if (indentation !== undefined && typeof indentation !== 'string') return __tjs.typeError('css.ts:457:css.indentation', 'string', indentation);

    const selectors = Object.keys(obj).map((selector) => {
        const body = obj[selector];
        if (typeof body === 'string') {
            if (selector === '@import') {
                return `@import url('${body}');`;
            }
            throw new Error('top-level string value only allowed for `@import`');
        }
        const rule = Object.keys(body)
            .map((prop) => renderStatement(prop, body[prop]))
            .join('\n');
        return `${indentation}${selector} {\n${rule}\n}`;
    });
    return selectors.join('\n\n');

  } finally { __tjs.popStack(); }
}
css.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": true
    },
    "indentation": {
      "type": {
        "kind": "string"
      },
      "required": false,
      "default": ""
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "css.ts:457"
}

/* line 470 */
/* TODO: TS types degraded — return: XinStyleRule */
export function initVars(obj) {
  try {
  __tjs.pushStack('css.ts:476:initVars');
  if (obj instanceof Error) return obj;
  if ((typeof obj !== 'object' || obj === null || Array.isArray(obj))) return __tjs.typeError('css.ts:476:initVars.obj', 'object', obj);

    warnDeprecated('initVars', 'initVars is deprecated. Just use _ and __ prefixes instead.');
    const rule = {};
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        const kabobKey = camelToKabob(key);
        rule[`--${kabobKey}`] =
            typeof value === 'number' && value !== 0 ? String(value) + 'px' : value;
    }
    return rule;

  } finally { __tjs.popStack(); }
}
initVars.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "source": "css.ts:476"
}

/* line 487 */
/* TODO: TS types degraded — map: XinStyleRule, return: XinStyleRule */
export function invertLuminance(map) {
  try {
  __tjs.pushStack('css.ts:490:invertLuminance');
  if (map instanceof Error) return map;

    const inverted = {};
    for (const key of Object.keys(map)) {
        const value = map[key];
        if (value instanceof Color) {
            inverted[key] = value.inverseLuminance;
        }
        else if (typeof value === 'string' &&
            value.match(/^(#[0-9a-fA-F]{3}|rgba?\(|hsla?\()/)) {
            inverted[key] = Color.fromCss(value).inverseLuminance;
        }
    }
    return inverted;

  } finally { __tjs.popStack(); }
}
invertLuminance.__tjs = {
  "params": {
    "map": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "css.ts:490"
}

export const varDefault = new Proxy({}, {
    get(target, prop) {
        if (target[prop] === undefined) {
            const varName = '--' + camelToKabob(prop);
            target[prop] = (val) => `var(${varName}, ${val})`;
        }
        return target[prop];
    },
});

const VarsType = Type('VarsType')

export const vars = new Proxy({}, {
    get(target, prop) {
        if (prop === 'default') {
            return varDefault;
        }
        if (target[prop] == null) {
            prop = camelToKabob(prop);
            const [, _varName, , isNegative, scaleText, method] = prop.match(/^([-\w]*?)((_)?(\d+)(\w?))?$/) || ['', prop];
            const varName = `--${_varName}`;
            if (scaleText != null) {
                const scale = isNegative == null
                    ? Number(scaleText) / 100
                    : -Number(scaleText) / 100;
                switch (method) {
                    case 'b': // brighten
                    case 's': // saturate
                    case 'h': // hue
                    case 'o': // alpha
                        {
                            // Return a CSS variable reference and register for computation
                            const outputVar = `--${prop}`;
                            Color.registerComputedColor(outputVar, varName, scale, method);
                            target[prop] = `var(${outputVar})`;
                        }
                        break;
                    case '':
                        target[prop] = `calc(var(${varName}) * ${scale})`;
                        break;
                    default:
                        console.error(method);
                        throw new Error(`Unrecognized method ${method} for css variable ${varName}`);
                }
            }
            else {
                target[prop] = `var(${varName})`;
            }
        }
        return target[prop];
    },
});

const CssVarBuilder = FunctionPredicate('CssVarBuilder', { params: { val: '' | 0.0 }, returns: '' })

export const ColorScheme = Union('ColorScheme', ['light', 'dark'])

export const ContrastPreference = Union('ContrastPreference', ['no-preference', 'more', 'less', 'custom'])

export const ThemePreferences = Type('ThemePreferences', undefined, { colorScheme: null, contrast: null, reducedMotion: false, reducedTransparency: false, forcedColors: false })

/* line 584 */
export function getThemePreferences() {
    const mq = (query) => typeof matchMedia !== 'undefined' && matchMedia(query).matches;
    return {
        colorScheme: mq('(prefers-color-scheme: dark)') ? 'dark' : 'light',
        contrast: mq('(prefers-contrast: more)')
            ? 'more'
            : mq('(prefers-contrast: less)')
                ? 'less'
                : mq('(prefers-contrast: custom)')
                    ? 'custom'
                    : 'no-preference',
        reducedMotion: mq('(prefers-reduced-motion: reduce)'),
        reducedTransparency: mq('(prefers-reduced-transparency: reduce)'),
        forcedColors: mq('(forced-colors: active)'),
    };
}
getThemePreferences.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "object",
      "shape": {
        "colorScheme": {
          "kind": "union",
          "members": [
            {
              "kind": "string"
            },
            {
              "kind": "string"
            }
          ]
        },
        "contrast": {
          "kind": "union",
          "members": [
            {
              "kind": "union",
              "members": [
                {
                  "kind": "union",
                  "members": [
                    {
                      "kind": "string"
                    },
                    {
                      "kind": "string"
                    }
                  ]
                },
                {
                  "kind": "string"
                }
              ]
            },
            {
              "kind": "string"
            }
          ]
        },
        "reducedMotion": {
          "kind": "boolean"
        },
        "reducedTransparency": {
          "kind": "boolean"
        },
        "forcedColors": {
          "kind": "boolean"
        }
      }
    }
  },
  "unsafeReturn": true,
  "source": "css.ts:567"
}

/* line 603 */
export function onThemePreferencesChange(callback) {
  try {
  __tjs.pushStack('css.ts:585:onThemePreferencesChange');
  if (callback instanceof Error) return callback;

    if (typeof matchMedia === 'undefined') {
        return () => { };
    }
    const queries = [
        '(prefers-color-scheme: dark)',
        '(prefers-contrast: more)',
        '(prefers-contrast: less)',
        '(prefers-contrast: custom)',
        '(prefers-reduced-motion: reduce)',
        '(prefers-reduced-transparency: reduce)',
        '(forced-colors: active)',
    ];
    const handler = () => callback(getThemePreferences());
    const mediaQueryLists = queries.map((q) => matchMedia(q));
    for (const mql of mediaQueryLists) {
        mql.addEventListener('change', handler);
    }
    return () => {
        for (const mql of mediaQueryLists) {
            mql.removeEventListener('change', handler);
        }
    };

  } finally { __tjs.popStack(); }
}
onThemePreferencesChange.__tjs = {
  "params": {
    "callback": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    }
  },
  "source": "css.ts:585"
}